export const ALGOLIA_PERSISTANT_PRODUCT_FILTERS = `isSKUAvailable: true AND onlineFrom < ${new Date().getTime()}`;
